import { render, staticRenderFns } from "./DataTable5.vue?vue&type=template&id=2201d3af&scoped=true"
import script from "./DataTable5.vue?vue&type=script&lang=js"
export * from "./DataTable5.vue?vue&type=script&lang=js"
import style0 from "./DataTable5.vue?vue&type=style&index=0&id=2201d3af&prod&lang=scss&scoped=true"
import style1 from "./DataTable5.vue?vue&type=style&index=1&id=2201d3af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2201d3af",
  null
  
)

export default component.exports